// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__vneqx","label":"Radio_label__32Y2-","checkMark":"Radio_checkMark__10Pc-","disabled":"Radio_disabled__39yPh"};